import React from "react";
import { LegalLayout } from "../components/LegalLayout";
import { NextSteps } from "../components/NextSteps";

const Complaints = () => (
  <LegalLayout overline="Legal" title="Complaints Procedure" lastUpdated="December 2025">
    <h2>Our commitment</h2>
    <p>
      We are committed to providing a high-quality legal service to all our clients. When something
      goes wrong, we need you to tell us about it. This will help us to improve our standards.
    </p>

    <h2>How to complain</h2>
    <p>
      If you have a concern, please first raise it with the partner handling your matter. If you
      remain unsatisfied, please contact our Client Care Partner in writing:
    </p>
    <ul>
      <li>By post: Client Care Partner, Lawfields Solicitors, 47 North Road, Southall, Middlesex UB1 2JL</li>
      <li>By email: <a href="mailto:info@lawfields.co.uk">info@lawfields.co.uk</a></li>
      <li>By telephone: 020 8574 0800</li>
    </ul>

    <NextSteps
      title="What happens next"
      steps={[
        {
          when: "Within 5 working days",
          title: "We acknowledge your complaint",
          body: "You will receive written acknowledgement from our Client Care Partner, including the name of the person who will be investigating.",
        },
        {
          when: "Within 21 working days",
          title: "We investigate & respond",
          body: "We review your file, speak with the fee-earner who acted for you, and write to you with our findings and any proposed resolution. If we need more time, we will tell you why.",
        },
        {
          when: "Within 14 days of our response",
          title: "Optional senior review",
          body: "If you remain dissatisfied, you may ask our Senior Partner for a final internal review.",
        },
        {
          when: "After 8 weeks or final response",
          title: "Legal Ombudsman",
          body: "You may take the complaint to the Legal Ombudsman (0300 555 0333 · legalombudsman.org.uk). Normally within 6 months of our final response.",
        },
      ]}
    />

    <h2>Legal Ombudsman</h2>
    <p>
      If you are still not satisfied with our final response, or we have not responded within 8
      weeks, you may take your complaint to the Legal Ombudsman:
    </p>
    <ul>
      <li>Website: <a href="https://www.legalombudsman.org.uk" target="_blank" rel="noreferrer">www.legalombudsman.org.uk</a></li>
      <li>Telephone: 0300 555 0333</li>
      <li>Email: <a href="mailto:enquiries@legalombudsman.org.uk">enquiries@legalombudsman.org.uk</a></li>
      <li>Post: Legal Ombudsman, PO Box 6167, Slough SL1 0EH</li>
    </ul>
    <p>
      Normally you must refer the complaint to the Ombudsman within 6 months of our final response
      and within one year of the act or omission, or one year from when you should reasonably have
      known there was cause for complaint.
    </p>

    <h2>Solicitors Regulation Authority</h2>
    <p>
      Where a complaint relates to our professional conduct or behaviour (such as dishonesty or
      breach of the SRA Standards and Regulations), you may report it directly to the Solicitors
      Regulation Authority at <a href="https://www.sra.org.uk" target="_blank" rel="noreferrer">www.sra.org.uk</a>.
    </p>

    <h2>No charge</h2>
    <p>We will not charge you for handling your complaint.</p>
  </LegalLayout>
);

export default Complaints;
